export default __webpack_public_path__ + "static/media/SOCIOCREDZ_LOGO.34f0c6cc.svg";